import { render } from "./themeWorks.vue?vue&type=template&id=2e73e2b6&scoped=true"
import script from "./themeWorks.vue?vue&type=script&lang=js"
export * from "./themeWorks.vue?vue&type=script&lang=js"

import "./themeWorks.vue?vue&type=style&index=0&id=2e73e2b6&lang=less&scoped=true"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e73e2b6"]])

export default __exports__